import * as React from 'react';
import {connect} from 'react-redux';
import {setScreen} from "../../actions/activation";
import {deactivate} from "../../actions/activation";

class ErrorComponent extends React.Component {
	state = {};

	constructor(props) {
		super(props);
	}

	render() {
		const {error} = this.props;
		const errorTexts = window.errorTexts ? window.errorTexts : {};
		return (
			<div className={'after-share-gloop'}>
				<div className={'after-share-block'}>
					<div className={'aftershare-image-gloop'}>
						<img src={'/wp-content/themes/twentynineteen-child/images/default.gif'} alt={""} />
					</div>
					<div className={'aftershare-content'}>
						<h4>{errorTexts[error] ? errorTexts[error].title : 'Error'}</h4>
						<p>{errorTexts[error] ? errorTexts[error].text : 'Error' }</p>
						<ul className={'benefits-list-gloop'}>
							<li>Keep sent & received Gloops</li>
							<li>Keep your contacts</li>
							<li>Receive awesome offers</li>
						</ul>
						<a
							href={'href'}
							className={'signup-gloop'}
							onClick={ (e) => {
								e.preventDefault();
								setScreen('gloop');
							}}
						>Sign Up</a>
						<a
							href={'href'}
							className={'cancel'}
							onClick={ (e) => {
								e.preventDefault();
								deactivate();
								setScreen('gloop');
							}}
						>No thanks</a>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		error: state.error
	};
}
const Error = connect(mapStateToProps)(ErrorComponent)
export default Error;
